import { render, staticRenderFns } from "./OtherLegalDocs.vue?vue&type=template&id=47678416&scoped=true"
import script from "./OtherLegalDocs.vue?vue&type=script&lang=js"
export * from "./OtherLegalDocs.vue?vue&type=script&lang=js"
import style0 from "./OtherLegalDocs.vue?vue&type=style&index=0&id=47678416&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47678416",
  null
  
)

export default component.exports